import request from "@/utils/request";
const preFixUrl = "/bac";

/**
 * 获取院区提示弹窗信息
 * @param {*} data
 * @returns
 */
export const getRemindList = (data) => {
  return request({
    url: `${preFixUrl}/remind/list`,
    method: "get",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 查询就诊人
 * @param {*} data
 * @returns
 */
export const getListPatients = (data) => {
  return request({
    url: `${preFixUrl}/patients/list_patients`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 新增就诊人
 * @param {*} data
 * @returns
 */
export const addPatient = (data) => {
  return request({
    url: `${preFixUrl}/patients/add_patient`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 编辑就诊人
 * @param {*} data
 * @returns
 */
export const editPatient = (data) => {
  return request({
    url: `${preFixUrl}/patients/update_patients`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 删除就诊人
 * @param {*} data
 * @returns
 */
export const deletePatient = (id) => {
  return request({
    url: `${preFixUrl}/patients/delete_patient/${id}`,
    method: "DELETE",
    headers: {
      ["Content-Type"]: "application/json",
    },
  });
};

/**
 * 查询就诊记录
 * @param {*} data
 * @returns
 */
export const getPatients = (params) => {
  return request({
    url: `${preFixUrl}/patients/get_patients`,
    method: "get",
    headers: {
      ["Content-Type"]: "application/json",
    },
    params,
  });
};
/**
 * 查询服务工单
 * @param {*} data
 * @returns
 */
export const getServiceListRequest = (data) => {
  return request({
    url: `${preFixUrl}/workOrder/myWorkOrder`,
    method: "POST",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 新增服务工单
 * @param {*} data
 * @returns
 */
export const addServiceRequest = (data) => {
  return request({
    url: `${preFixUrl}/workOrder/addWorkOrder`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 删除服务工单
 * @param {*} data
 * @returns
 */
export const deleteServiceRequest = (data) => {
  return request({
    url: `${preFixUrl}/workOrder/deleteWorkOrder`,
    method: "POST",
    data,
    headers: {
      ["Content-Type"]: "application/json",
    },
  });
};

/**
 * 修改密码
 * @param {*} data
 * @returns
 */
export const updatePassword = (data) => {
  return request({
    url: `${preFixUrl}/user/restUserPassword`,
    method: "POST",
    data,
    headers: {
      ["Content-Type"]: "application/json",
    },
  });
}

/**
 * 查询用户信息
 * @param {*} data
 * @returns
 */
export const getUserDetail = (userId) => {
  return request({
    url: `${preFixUrl}/user/getUserDetail?userId=${userId}`,
    method: 'post',
  })
}

/**
 * 修改用户信息
 * @param {*} data
 * @returns
 */
export const updateUserInfo = (data) => {
  return request({
    url: `${preFixUrl}/user/updateUser`,
    method: 'post',
    data,
    headers: {
      ["Content-Type"]: "application/json",
    },
  });
}

/**
 * 修改手机号验证码
 * @param {*} params
 * @returns
 * */
export const updatePhoneCode = (params) => {
  return request({
    url: `${preFixUrl}/workOrder/workOrderPhoneMsg`,
    method: 'get',
    params,
  });
}

/**
 * 修改手机号
 * @param {*} data
 * @returns
 * */
export const updateUserPhone = (data) => {
  return request({
    url: `${preFixUrl}/user/updateUserPhone`,
    method: 'post',
    data,
    headers: {
      ["Content-Type"]: "application/json",
    },
  });
}